import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import HowItWorks from "@/pages/HowItWorks";
import DrinkMachines from "@/pages/DrinkMachines";
import SnackMachines from "@/pages/SnackMachines";
import ComboMachines from "@/pages/ComboMachines";
import MicroMarkets from "@/pages/MicroMarkets";
import MachineSuggestions from "@/pages/MachineSuggestions";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/services/drink-machines" element={<DrinkMachines />} />
            <Route path="/services/snack-machines" element={<SnackMachines />} />
            <Route path="/services/combo-machines" element={<ComboMachines />} />
            <Route path="/services/micro-markets" element={<MicroMarkets />} />
            <Route path="/suggestions" element={<MachineSuggestions />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
